import { useEffect, useRef, useState } from "react";
import { ReactTagManager } from 'react-gtm-ts';
import { Header } from "./inscription";
import { Link, useNavigate } from "react-router-dom";
import { RoundGreyPlain } from "components/ui/Buttons/generic/GenericButton";
import { post } from "services/config";
import Eye from '../assets/svg/eye.svg';

const setDescription = (desc: any) => {
    const el = document.querySelector("meta[name='description']");
    if(el!== null){
        el.setAttribute('content',desc);
    }
}

export default function Connexion(){

    const [connecting, setConnecting]= useState(false);

    const [hasErrors, setHasErrors]= useState<{
        username: {hasErrors: boolean, message: string},
        password: {hasErrors: boolean, message: string}
    }> ({
        username: {hasErrors: false, message: ""},
        password: {hasErrors: false, message: ""}
    });

    const passField= useRef<HTMLInputElement>(null);

    const makePassVisible= (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        if (passField.current) {
            passField.current.type= "text";
        }
    };
    const makePassHidden= (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        if (passField.current) {
            passField.current.type= "password";
        }
    };

    const togglePassHidden= (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        if (passField.current) {
            if (passField.current.type=== "password"){
                passField.current.type= "text";
            } else {
                passField.current.type= "password";
            }
        }
    };

    useEffect(()=> {
        document.title= "Connectez-vous à votre espace Wall of Share";
        const desc= "Connectez-vous à votre compte Wall of Share pour accéder à votre tableau de bord et gérer vos projets ou missions en toute simplicité.";
        setDescription(desc);
    },[]);

    const [credentials, setCredentials]= useState<{username: string, password: string}>({username: "", password: ""});
    const handleInputs= (event: any) => {
        if(!connecting) {
            setCredentials({...credentials, [event.currentTarget.id]: event.currentTarget.value});
        }
        const newErr: any= {...hasErrors};
        newErr[event.currentTarget.id].hasErrors= false;
        setHasErrors(newErr);
    };
    const history= useNavigate();
    const useValidate= () => {
        if(credentials.username.trim()=== ""){
            const newErrors= {...hasErrors};
            newErrors.username.hasErrors= true;
            newErrors.username.message= "Vous devez entrer votre nom d'utilisateur.";
            setHasErrors(newErrors);
            return false;
        }
        if(credentials.password=== ""){
            const newErrors= {...hasErrors};
            newErrors.password.hasErrors= true;
            newErrors.password.message= "Vous devez entrer votre mot de passe.";
            setHasErrors(newErrors);
            return false;
        }
        return true;
    };

    const useConnectionAttempt= (event: any) => {
        event.preventDefault();
        
        // ReactTagManager.action({
        //     event: 'click_signInButton',
        //     clickText: 'se_connecter',  // c'est pas une obligation mais il se pourrais qu'on s'en serve au niveau de certains button et 
        //   });
        
        if (useValidate()){
            setConnecting(true);

            const dbname= process.env.REACT_APP_API_DB_NAME || "wos_db";
            const withCredentials= !(process.env.REACT_APP_WITH_CREDENTIALS=== 'false');

            const reqBody= {
                jsonrpc: "2.0",
                method: "call",
                params: {
                    login: credentials.username,
                    password: credentials.password,
                    db: dbname
                },
                id: new Date().getTime()
            };

            
            const portalPath= window.location.hostname.includes('.fr') ? "https://portal.wall-of-share.fr/web": "https://portal.wall-of-share.com/web";

            post(
                'web/session/authenticate',
                reqBody,
                {withCredentials: withCredentials}
            ).then(response=> {
                if(!(response.status=== 200)){
                    throw new Error('HTTP error! Status: ' + response.status);
                } else {
                    const data: any= response.data;
                    if (data.result){
                        console.log("Login successful!\n", response.data);
                        localStorage.setItem("user", JSON.stringify(data.result));
                        if (data.result.is_worker || data.result.portal_worker) {
                            history('/profil');
                        } else {
                            // history(portalPath);
                            window.location.href= portalPath;//history() only workd on local redirections using relative paths
                        }
                    } else {
                        console.log('login failed\n');
                        setConnecting(false);
                        setHasErrors({username: {hasErrors: true, message: ""}, password: {hasErrors: true, message: "Nom d'utilisateur et/ou mot de passe erronés."}});
                    }
                }
            }).catch(error=> {
                console.error('login failed!\n', error);
            });

            console.log("Connexion");
        } else{
            return;
        }
    };
    
    return (
        <>
        <div className="w-full min-h-[100vh] bg-[#f4f4f5]">
            <Header />
            <div className="flex flex-col gap-[69px] items-center py-[110px] w-[80vw] max-w-[766px] mx-auto">
                <div className="flex flex-col gap-[10px] lg:max-w-[535px] max-w-[80vw] lg:mx-0 mx-auto self-start">
                    <h1 className="lg:text-[60px] lg:leading-[72px] text-[40px] leading-[48px] text-primary-blue font-semibold">Bienvenue chez <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500">Wall of Share</span> !</h1>
                    <p className="lg:text-[25px] lg:leading-[32.55px] text-[20px] leading-[26.04px] text-[#6f6f6f] font-normal font-dm-sans">Se connecter pour continuer sur Wall of Share.</p>
                </div>
                <form onSubmit={useConnectionAttempt} className="w-full flex flex-col lg:max-w-[766px] max-w-[80vw] gap-[69px]">
                    <div className="flex flex-col gap-[20px] w-full">
                        <div className="flex flex-col gap-[10px] w-full">
                            <input type="text" className="w-full rounded-[100px] bg-white px-[30px] py-[20px] font-normal font-dm-sans md:text-[25px] md:leading-[32.55px] text-[20px] leading-[26.04px] text-[#6f6f6f]" id="username" placeholder="Nom d'utilisateur" value={credentials.username} onChange={handleInputs} style={hasErrors.username.hasErrors ? {border: "1px solid red"}: {}} />
                            {hasErrors.username.hasErrors && <div className="text-[#f55] lg:text-[25px] lg:leading-[32.55px] text-[20px] leading-[26.04px] font-normal font-dm-sans">{hasErrors.username.message}</div>}
                        </div>
                        <div className="flex flex-col gap-[10px] w-full relative">
                            <input type="password" className="w-full rounded-[100px] bg-white px-[30px] py-[20px] font-normal font-dm-sans md:text-[25px] md:leading-[32.55px] text-[20px] leading-[26.04px] text-[#6f6f6f]" id="password" placeholder="Mot de passe" value={credentials.password} onChange={handleInputs} style={hasErrors.password.hasErrors ? {border: "1px solid red"}: {}} ref={passField}/>
                            <img src={Eye} alt="EYE" className="w-[2.5em] absolute top-[37px] right-[30px] cursor-pointer opacity-70 hover:opacity-100 transform translate-y-[-50%] hidden lg:block" onMouseDown={makePassVisible} onMouseUp={makePassHidden} onMouseLeave={makePassHidden}/>
                            <img src={Eye} alt="EYE" className="w-[2.5em] absolute top-[37px] right-[30px] cursor-pointer opacity-70 hover:opacity-100 transform translate-y-[-50%] lg:hidden block" onClick={togglePassHidden}/>
                            {hasErrors.password.hasErrors && <div className="text-[#f55] lg:text-[25px] lg:leading-[32.55px] text-[20px] leading-[26.04px] font-normal font-dm-sans">{hasErrors.password.message}</div>}
                            <input type="submit" className="hidden" />
                        </div>
                        <Link className="text-right w-full text-[18px] leading-[23.44px] font-dm-sans text-[#6f6f6f]" to="/mot-de-passe-perdu">J'ai perdu mon mot de passe</Link>
                    </div>
                    <div className="flex flex-col gap-[28px] w-full">
                        <RoundGreyPlain isButton={true} className="w-full flex items-center justify-center py-[20px] md:text-[25px] md:leading-[30px] text-[20px] leading-[24px] font-semibold" text={connecting ? "Connexion..." : "Se connecter"} onClick={useConnectionAttempt}/>
                        <p className="font-normal text-[20px] leading-[24px] text-primary-blue lg:text-left text-center max-w-[80vw] mx-auto md:mt-0 mt-[23.5px]">Vous n'avez pas encore de compte ? <Link className="font-semibold underline decoration-solid" to="/inscription">Inscrivez-vous</Link></p>
                    </div>
                </form>
            </div>
        </div>
        </>
    );
};

/**
 * Checks if the current user is a registerd worker by looking at the user data in local storage
 * @returns {boolean}
 */
export const isWorker= ()=> {
    const userStringData= localStorage.getItem('user');
    if (userStringData){
        const userData= JSON.parse(userStringData);
        if (userData.is_worker){
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
};

/**
 * Checks if the current user is a portal worker by looking at the user data in local storage
 * @returns {boolean}
 */
export const isPortalWorker= ()=> {
    const userStringData= localStorage.getItem('user');
    if (userStringData){
        const userData= JSON.parse(userStringData);
        if (userData.portal_worker){
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
};

/**
 * The current user can access the profile page if he is either a registered worker or a protal worker
 * @returns {boolean}
*/
export const hasProfileAccess= () => {
    console.log("Portal Worker --- ", isPortalWorker());
    console.log("Worker --- ", isWorker());
    console.log("this is how it is ----- ", isPortalWorker() || isWorker());
    return (isPortalWorker() || isWorker());
};